import styles from '../../assets/css/views/login.module.css';

import Input from '../../components/Input';
import { PrimaryButton } from '../../components/Buttons';
import { Link, useNavigate } from 'react-router-dom';

export const ResetPassword = (props) => {

    const navigate = useNavigate();

    return <div className={styles.container}>
        <div className={styles.wrapper}>
            <img className={styles.logo} alt="" src="https://accounts.xenfuma.com/filesystem/svg/xenfuma_logo_b.svg"/>
            <h1 className={styles.title}>{"Reset password"}</h1>
            <div className={styles.subtitle}>{"Enter your email below to receive further instructions on how to reset your password."}</div>
            <form>
                <Input placeholder={"Email"} type={"email"}/>
                <PrimaryButton className={styles.button} label={"Send Instructions"} onClick={(e) => {
                    e.setLoading(true);
                    setTimeout(() => {
                        navigate('/reset/sent')
                    }, 1000)
                }}/>
            </form>
            <div className={styles['sign-up']}>
                <span><Link to={"/login"}><span className={styles.clickable}>{"Go Back"}</span></Link></span>
            </div>
        </div>
    </div>

}

export default ResetPassword